<template>
  <div>
    <div class="facebook-template-list">
      <slot></slot>
    </div>
    <v-pagination
      :value="page"
      :length="totalPages"
      :total-visible="7"
      class="mt-2"
      @input="$emit('update:page', $event)"
    ></v-pagination>
  </div>
</template>

<script>
export default {
  props: {
    page: {
      type: Number,
      default: 1
    },
    totalPages: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style lang="scss" scoped>
.facebook-template-list {
  > * + * {
    margin-top: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/facebook-template/FacebookTemplateList.vue